import { Row, Col } from "reactstrap";
import { H4 } from "../../AbstractElements";

interface StaticLabelProps {
    labels: string[];
}


const StaticLabel = ({ labels }: StaticLabelProps) => {
    const columnWidths = [2,1,2, 1, 1, 1, 1,1,1]; // match your table columns
    return (
        <Row className="d-flex align-items-center " style={{justifyContent:'space-evenly',textAlign:'center',margin:0}}>
            {labels.map((label, index) => (
                <Col  key={index} style={{
                    // padding: "4px 8px", 
                    marginBottom: "2px", 
                    flex:columnWidths[index]
                }}>
                    <H4 style={{ fontSize: "0.9rem" }}>{label}</H4>
                </Col>
            ))}
        </Row>
    );
};

export default StaticLabel;
